import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import ProjectCopyPlanDetails from "./plan-details";
import ProjectFilePlanContextProvider from "./plan-details/context/project-file-plan-context-provider.tsx";
import MeasureOverviewLayout from "../../measures/layouts/overview/index.tsx";

const ProjectCopyLayout : React.FC = () => {
    const [searchParams] = useSearchParams();
    const fileIdLeft = (searchParams.get('fileId') as string);

    const [fileIdRight, setFileIdRight] = useState<string | undefined>(undefined);

    return fileIdLeft != null ? (
        <ProjectFilePlanContextProvider 
            fileIdLeft={fileIdLeft}
            fileIdRight={fileIdRight}
            setFileIdRight={setFileIdRight}
        >
            <ProjectCopyPlanDetails />
        </ProjectFilePlanContextProvider>
    ) : (
        <MeasureOverviewLayout />
    )
}

export default ProjectCopyLayout;